<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <slot name="name">
        <div class="card-header">
          置顶
        </div>
      </slot>
      <Stick v-for="item in datas" :key="item.id" :item="item"/>
    </div>
    <Loading :loading="false"/>
  </div>
</template>

<script>
import { get } from '../utils/request'
import Stick from '../components/Stick.vue'
import Loading from './Loading.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('refresh')
export default {
  props: [
    'selfStyle'
  ],
  components: {
    Stick,
    Loading
  },
  data () {
    return {
      datas: [],
      loading: false
    }
  },
  mounted () {
    this.getArticle()
  },
  computed: {
    ...mapGetters({
      getDownRefresh: 'getDownRefresh'
    })
  },
  watch: {
    getDownRefresh (value) {
      if (!value) {
        this.getArticle()
      }
    }
  },
  methods: {
    getArticle () {
      this.loading = true
      const promise = get({
        url: '/bbs/getRecommendArticle'
      })
      promise.then(res => {
        const { status, data } = res
        if (Object.is(status, 200)) {
          this.datas = data
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.label {
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-right: 10px;
  font-size: 12px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
}
.card {
  box-sizing: border-box;
  background: transparent;
  padding: 0 7.5px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
